import { render, staticRenderFns } from "./switching-sidebar.vue?vue&type=template&id=397f17b7&scoped=true&lang=pug&"
import script from "./switching-sidebar.vue?vue&type=script&lang=js&"
export * from "./switching-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./switching-sidebar.vue?vue&type=style&index=0&id=397f17b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f17b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VNavigationDrawer})
